import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
    interface Window {
        gtag?: (...args: any[]) => void;
    }
}

/**
 * Sends a Google Analytics page_view on every client-side navigation (the site is
 * a single-page app, so GA's automatic page view would only fire once per visit).
 * window.gtag only exists on the production domain - see public/index.html - so
 * this is a no-op on staging and local development. The admin area is not tracked.
 */
const AnalyticsTracker: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        if (typeof window.gtag !== 'function') return;
        if (location.pathname.startsWith('/admin')) return;
        window.gtag('event', 'page_view', {
            page_path: location.pathname + location.search,
            page_location: window.location.href,
            page_title: document.title,
        });
    }, [location.pathname, location.search]);

    return null;
};

export default AnalyticsTracker;
